import { el, clear } from '../utils/dom.js';
import { Notifications } from '../api/resources.js';
import { fromNow } from '../utils/format.js';

let bellEl = null;
let panelEl = null;
let countEl = null;
let pollInterval = null;
let unread = 0;

export function buildNotificationBell() {
  countEl = el('span', { class: 'badge danger', style: 'position:absolute; top:-4px; right:-4px; padding: 0 6px; font-size: 10px; display:none; pointer-events:none;' });
  bellEl = el('button', {
    class: 'btn ghost icon',
    style: 'position: relative;',
    title: 'Notificaciones',
    onclick: togglePanel,
  }, '🔔', countEl);

  panelEl = el('div', {
    style: `
      position: absolute; top: 56px; right: 16px;
      width: 360px; max-height: 480px; overflow-y: auto;
      background: var(--surface); border: 1px solid var(--border);
      border-radius: var(--r-lg); box-shadow: var(--sh-3);
      z-index: 30; display: none;
    `,
  });

  document.addEventListener('click', (e) => {
    if (panelEl.style.display === 'block' && !bellEl.contains(e.target) && !panelEl.contains(e.target)) {
      panelEl.style.display = 'none';
    }
  });

  startPolling();
  return { bell: bellEl, panel: panelEl };
}

export function startPolling() {
  if (pollInterval) clearInterval(pollInterval);
  refreshCount();
  pollInterval = setInterval(refreshCount, 30_000);
}

export function stopPolling() {
  if (pollInterval) { clearInterval(pollInterval); pollInterval = null; }
}

async function refreshCount() {
  try {
    const r = await Notifications.unreadCount();
    setUnread(r.unread);
  } catch {}
}

function setUnread(n) {
  unread = n;
  if (!countEl) return;
  if (n > 0) {
    countEl.textContent = n > 99 ? '99+' : String(n);
    countEl.style.display = 'inline-block';
  } else {
    countEl.style.display = 'none';
  }
}

async function togglePanel() {
  const visible = panelEl.style.display === 'block';
  if (visible) { panelEl.style.display = 'none'; return; }
  panelEl.style.display = 'block';
  await loadPanel();
}

async function loadPanel() {
  clear(panelEl);
  panelEl.appendChild(el('div', { class: 'flex justify-between items-center', style: 'padding: var(--sp-3); border-bottom: 1px solid var(--border);' },
    el('div', { class: 'text-bold' }, 'Notificaciones'),
    el('button', { class: 'btn ghost sm', onclick: async () => {
      await Notifications.markAllRead();
      setUnread(0);
      loadPanel();
    } }, 'Marcar todas leidas'),
  ));

  const list = el('div');
  panelEl.appendChild(list);
  list.innerHTML = '<div class="muted" style="padding: var(--sp-4); text-align:center">Cargando...</div>';

  try {
    const res = await Notifications.list({ limit: 30 });
    const rows = res.data || [];
    setUnread(res.unread || 0);

    if (rows.length === 0) {
      list.innerHTML = '<div class="muted" style="padding: var(--sp-5); text-align:center">Sin notificaciones</div>';
      return;
    }

    list.replaceChildren();
    for (const n of rows) {
      const priorityCls = n.priority === 'critica' ? 'danger' :
                          n.priority === 'alta'    ? 'warn'   :
                          n.priority === 'media'   ? 'info'   : 'muted';
      const item = el('div', {
        style: `padding: var(--sp-3); border-bottom: 1px solid var(--border); cursor: pointer; ${n.is_read ? 'opacity: 0.65;' : 'background: var(--surface-2);'}`,
        onclick: async () => {
          if (!n.is_read) await Notifications.markRead([n.id]);
          panelEl.style.display = 'none';
          if (n.link) window.location.hash = '#' + n.link;
          refreshCount();
        },
      },
        el('div', { class: 'flex justify-between items-center mb-2' },
          el('span', { class: `badge ${priorityCls}` }, n.priority),
          el('span', { class: 'text-xs muted' }, fromNow(n.created_at)),
        ),
        el('div', { class: 'text-bold mb-2' }, n.title),
        n.message ? el('div', { class: 'text-sm muted' }, n.message) : null,
      );
      list.appendChild(item);
    }
  } catch (ex) {
    list.innerHTML = `<div class="empty">Error: ${ex.message}</div>`;
  }
}
